import { useEffect, useRef, useCallback } from "react";
import { useLatido } from "./useLatido";

const HEARTBEAT_INTERVAL = 30_000; 
const ENDPOINT = "/api/presence/heartbeat";

export default function usePageTracker(page, section = null, lessonId = null, action = "studying") {
  const timerRef    = useRef(null);
  const abortRef    = useRef(null);

  const sendHeartbeat = useCallback(async () => {
    console.log(`📡 [RADAR] Preparando latido para la página: ${page}`);
    const token = localStorage.getItem("token");
    if (!token) {
        console.warn("❌ [RADAR] Abortado: No se encontró el token de sesión.");
        return;
    }

    if (abortRef.current) abortRef.current.abort();
    abortRef.current = new AbortController();

    try {
      console.log(`🚀 [RADAR] Disparando conexión a la base de datos...`);
      const res = await fetch(ENDPOINT, {
        method:  "POST",
        headers: {
          "Content-Type":  "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({ page, section, lesson_id: lessonId, action }),
        signal: abortRef.current.signal,
      });
      console.log(`✅ [RADAR] Respuesta del servidor: ${res.status} OK`);
    } catch (err) {
      if (err.name !== "AbortError") {
        console.error("❌ [RADAR] Choque fatal en la red:", err.message);
      }
    }
    // Un latido de presencia siempre es «lo mismo»: que afloje el ritmo cuando
    // el alumno lleva un rato en la misma pantalla.
    return false;
  }, [page, section, lessonId, action]);

  // ── QUIEN NO ESTÁ MIRANDO, NO ESTÁ PRESENTE (19-09-2026) ────────────────
  // Este latido dice «sigo aquí» cada 30 segundos y ESCRIBE en la base. Con la
  // pestaña oculta seguía diciéndolo: el alumno constaba como estudiando con la
  // app en el bolsillo, y a gerencia le aparecía «en vivo» quien no estaba.
  // Ahora calla con la pestaña oculta —que es la verdad— y vuelve a latir en
  // cuanto el alumno regresa.
  useLatido(sendHeartbeat, { base: HEARTBEAT_INTERVAL, techo: 120_000 });

  useEffect(() => () => {
    if (abortRef.current) abortRef.current.abort();
  }, []);
}